import {create, all} from "mathjs";
import { Security } from "../proto/generated/security";

const math = create(all);

export const availableFilters = ["strike"]

// map for maintaining whether filter prefers referenced security whenever available
export const filterDerivedUsageMap: Record<string, boolean> = {
    strike: true
}

math.import({
    strike: function(sec: Security){
        return (sec.strikePrice || 0)/(sec.priceMultiplier || 100)
    }
})

export default math;